import axios from 'axios';

const LOGIN_STORAGE_KEY = 'codex-api-login-user';
const TOKEN_STORAGE_KEY = 'codex-api-auth-token';

const http = axios.create({
  baseURL: '/api',
  timeout: 10000
});

function redirectToLogin() {
  window.localStorage.removeItem(LOGIN_STORAGE_KEY);
  window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  if (window.location.pathname === '/login') {
    return;
  }
  const redirect = window.location.pathname + window.location.search + window.location.hash;
  window.location.href = '/login?redirect=' + encodeURIComponent(redirect);
}

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.exp && Number(payload.exp) * 1000 <= Date.now();
  } catch (error) {
    return false;
  }
}

http.interceptors.request.use(config => {
  const token = window.localStorage.getItem('codex-api-auth-token');
  if (token) {
    if (isTokenExpired(token)) {
      redirectToLogin();
      return Promise.reject(new Error('AUTH_TOKEN_EXPIRED'));
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  response => {
    const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);
    if (token && response.data && Number(response.data.code) === 401) {
      redirectToLogin();
    }
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default http;
